<div class="row space-v-m">
  <h2>
    <ng-container>
      <div class="row v-align-center space-l-xl" *ngIf="totalElements">
        <div class="col-6">
          {{ totalElements }} {{ totalElements === 1 ? ('RECIPE_FOUND' | translate) : ('RECIPES_FOUND' | translate) }}
        </div>
      </div>
      <ng-container *ngIf="hasNoResult">
        <span>{{ 'NO_RESULT_FOR_QUERY' | translate }}</span>
      </ng-container>
    </ng-container>
  </h2>
</div>

<app-data-table
  [tableData]="tableData"
  [displayInfo]="displayInfo"
  [columnConfigs]="columnConfigs"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [tableName]="'communitiesRecipes'"
  [defaultSortActive]="'modificationDate'"
  [defaultSortDirection]="'desc'"
  (filterChanged)="onFilterChanged($event)"
></app-data-table>
